module.exports = __webpack_public_path__ + "img/keypal-color-0.6e4f2b4a.png";